import React, { Component } from 'react';
import '../../styles/components/status-tab.scss';
class StatusTabs extends Component {
  state = {
    activeTab: this.props.tabs?.[0]?.key || '',
  };

  handleTabClick = (key) => {
    this.setState({ activeTab: key });

    if (this.props.onTabChange) {
      this.props.onTabChange(key);
    }
  };

  render() {
    const { activeTab } = this.state;
    const { tabs } = this.props;

    return (
      <div className="status-tabs">
        {tabs.map((tab) => (
          <div
            key={tab.key}
            className={`tab-item ${activeTab === tab.key ? 'active' : ''}`}
            onClick={() => this.handleTabClick(tab.key)}
          >
            <span className="tab-label">{tab.label}</span>
            <span className="tab-count">{tab.count}</span>
          </div>
        ))}
      </div>
    );
  }
}

export default StatusTabs;
